import { Service } from '../service';
import { HttpClientService } from '../http-client/http-client.service';
import { Observable } from 'rxjs/Observable';
import { Injectable } from '@angular/core';

@Injectable()
export class PersonService extends Service{

    constructor(
        private http: HttpClientService
    ) {
        super();
    }

    public getByDocumentNumber(documentNumber: string): Observable<any> {
        const url = 'persons/byDocumentNumber/' + documentNumber;
        return this.http.get(url).map(response => {
            const r = response.json();
            let tutor;
            if (r.ResultCode === 1) {
                tutor = r.Result;
            } else {
                console.error('TutorService > getById > response', r);
            }
            return tutor;
        }).catch(this.handleError);
    }
}



// WEBPACK FOOTER //
// ./src/app/main/services/person/person.service.ts